export default __webpack_public_path__ + "static/media/menu.349647b7.svg";